<template>
	<div class="border-b bg-white py-5 w-full">
		<div
			class="app-page-title px-6 w-full mx-auto"
			:class="{ 'full-width': fullWidth, 'no-padding': noPadding }"
		>
			<slot />
		</div>
		<slot name="actions" />
	</div>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		fullWidth?: boolean;
		noPadding?: boolean;
	}>(),
	{
		fullWidth: false,
		noPadding: false,
	},
);
</script>

<style lang="scss">
.app-page-title {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;
	row-gap: 6px;
	width: 100%;
	max-width: 1000px;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-size: 1.5rem;
		margin: 0;
	}

	&.full-width {
		max-width: unset;
	}

	&.no-padding {
		padding: 0;
		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			padding: 0;
		}
	}

	@media screen and (max-width: var(--mobile-size)) {
		padding: 0.75rem;
		padding-bottom: 0;

		flex-direction: column;

		&:last-child {
			margin-bottom: 0.75rem;
		}
	}

	> div {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.5rem;
	}
}
</style>
